import type { Camera } from '../renderer/Camera';

/** Perlin's smootherstep — zero velocity AND zero acceleration at both ends. */
function ease(t: number): number {
  return t * t * t * (t * (t * 6 - 15) + 10);
}

/**
 * Manages smooth animated camera transitions (position, zoom, pitch).
 * Owns all transition state; CameraController delegates animation to this.
 */
export class CameraTransition {
  private _t = 1;
  private _startX = 0;
  private _startY = 0;
  private _startZ = 0;
  private _startZoom = 0;
  startPitch = 0;
  endPitch = 0;

  get active(): boolean { return this._t < 1; }

  begin(cam: Camera, zoom: number, startPitch: number, endPitch: number): void {
    this._t = 0;
    this._startX = cam.target.x;
    this._startY = cam.target.y;
    this._startZ = cam.target.z;
    this._startZoom = zoom;
    this.startPitch = startPitch;
    this.endPitch = endPitch;
  }

  advance(dt: number, speed: number): number {
    this._t = Math.min(1, this._t + dt * speed);
    return ease(this._t);
  }

  interpolateTarget(
    cam: Camera, endX: number, endY: number, endZ: number, e: number,
  ): void {
    cam.target.x = this._startX + (endX - this._startX) * e;
    cam.target.y = this._startY + (endY - this._startY) * e;
    cam.target.z = this._startZ + (endZ - this._startZ) * e;
  }

  interpolateZoom(zoomTarget: number, e: number): number {
    return this._startZoom + (zoomTarget - this._startZoom) * e;
  }

  currentPitch(): number {
    const e = this._t * this._t * this._t * (this._t * (this._t * 6 - 15) + 10);
    return this.startPitch + (this.endPitch - this.startPitch) * e;
  }
}
